import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    standalone: false
})
export class SuccessDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
